<template>
<span v-if="$can(permissions.ADMIN_SETTINGS.EDIT_SETTING)">
  <el-button
    id="btn-sage-configuration-dialog"
    type="success"
    plain
    @click="dialogVisible = true"
    size="mini"
    class="button-action-default"
  >
    {{ $t('admin.settings.sage.title') }}
  </el-button>
  <el-dialog
    v-on:open="handleOpen"
    :title="$t('admin.settings.sage.title')"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    width="70%"
    append-to-body
    class="dialog-with-cols"
  >
    <el-form :model="form" :rules="formRules" ref="form" label-position="top" size="mini">
      <el-row>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.settings.sage.senderId')" prop="senderId">
            <el-input
                v-model="form.senderId"
                v-alphanumeric-validation
                maxlength="30"
                clearable
                class="inline-input"
                id="form-product-description"
                :disabled="loading"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.settings.sage.senderPassword')" prop="senderPassword">
            <el-input
                v-model="form.senderPassword"
                v-alphanumeric-validation
                type="password"
                maxlength="30"
                clearable
                class="inline-input"
                id="form-product-description"
                :disabled="loading"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.settings.sage.companyId')" prop="companyId">
            <el-input
              v-model="form.companyId"
              v-alphanumeric-validation
              maxlength="30"
              clearable
              class="inline-input"
              id="form-product-description"
              :disabled="loading"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.settings.sage.userId')" prop="userId">
            <el-input
              v-model="form.userId"
              v-alphanumeric-validation
              maxlength="30"
              clearable
              class="inline-input"
              id="form-product-description"
              :disabled="loading"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.settings.sage.userPassword')" prop="userPassword">
            <el-input
              v-model="form.userPassword"
              v-alphanumeric-validation
              type="password"
              maxlength="30"
              clearable
              class="inline-input"
              id="form-product-description"
              :disabled="loading"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.settings.sage.companyLocation')" prop="companyLocation">
            <el-input
              v-model="form.companyLocation"
              v-alphanumeric-validation
              maxlength="30"
              clearable
              class="inline-input"
              id="form-product-description"
              :disabled="loading"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.settings.sage.defaultAccount')" prop="defaultAccount">
            <el-input
                v-model="form.defaultAccount"
                v-numeric-validation
                maxlength="30"
                clearable
                class="inline-input"
                id="form-product-description"
                :disabled="loading"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.settings.sage.defaultDepartment')" prop="defaultDepartment">
            <el-input
                v-model="form.defaultDepartment"
                v-numeric-validation
                maxlength="30"
                clearable
                class="inline-input"
                id="form-product-description"
                :disabled="loading"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="12" class="form-vertical-item">
          <el-form-item :label="$t('admin.settings.sage.defaultLocation')" prop="defaultLocation">
            <el-input
                v-model="form.defaultLocation"
                v-numeric-validation
                maxlength="30"
                clearable
                class="inline-input"
                id="form-product-description"
                :disabled="loading"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button
        type="primary"
        id="form-save-button"
        @click="submitForm"
        size="mini"
      >
        {{ $t('common.save') }}
      </el-button>
      <el-button
        id="form-refresh-button"
        @click="resetForm"
        size="mini"
      >
        {{ $t('admin.settings.sage.reset') }}
      </el-button>
    </div>
  </el-dialog>
</span>
</template>

<script>
import { Message } from 'element-ui';
import { mapActions } from 'vuex';
import constants from '@/utils/constants';

export default {
  name: 'SageConfigurationDialog',
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        senderId: null,
        senderPassword: null,
        companyId: null,
        userId: null,
        userPassword: null,
        companyLocation: null,
        defaultAccount: null,
        defaultDepartment: null,
        defaultLocation: null
      },
      defaultValues: {},
      formRules: {
        senderId: [
          {
            required: true,
            message: this.$t('admin.settings.sage.errors.fieldRequired'),
            trigger: 'blur'
          }
        ],
        senderPassword: [
          {
            required: true,
            message: this.$t('admin.settings.sage.errors.fieldRequired'),
            trigger: 'blur'
          }
        ],
        companyId: [
          {
            required: true,
            message: this.$t('admin.settings.sage.errors.fieldRequired'),
            trigger: 'blur'
          }
        ],
        userId: [
          {
            required: true,
            message: this.$t('admin.settings.sage.errors.fieldRequired'),
            trigger: 'blur'
          }
        ],
        userPassword: [
          {
            required: true,
            message: this.$t('admin.settings.sage.errors.fieldRequired'),
            trigger: 'blur'
          }
        ],
        companyLocation: [
          {
            required: true,
            message: this.$t('admin.settings.sage.errors.fieldRequired'),
            trigger: 'blur'
          }
        ],
        defaultAccount: [
          {
            required: true,
            message: this.$t('admin.settings.sage.errors.fieldRequired'),
            trigger: 'blur'
          }
        ],
        defaultDepartment: [
          {
            required: true,
            message: this.$t('admin.settings.sage.errors.fieldRequired'),
            trigger: 'blur'
          }
        ],
        defaultLocation: [
          {
            required: true,
            message: this.$t('admin.settings.sage.errors.fieldRequired'),
            trigger: 'blur'
          }
        ]
      }
    };
  },
  methods: {
    ...mapActions({
      getSageSettings: 'adminSettings/getSageSettings',
      updateSageSettings: 'adminSettings/updateSageSettings',
    }),
    handleOpen() {
      this.loading = true;
      this.getSageSettings().then((response) => {
        this.defaultValues = response.data;
        this.resetForm();
        this.loading = false;
      });
    },
    resetForm() {
      this.form = { ...this.defaultValues };
      this.$refs.form.resetFields();
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.updateSageSettings(this.form)
            .then((response) => {
              this.$message.success(response.message);
              this.dialogVisible = false;
            })
            .finally(() => {
              loading.close();
            });
        }
      });
    }
  }
};
</script>
